exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2y3kt{position:relative;margin-bottom:30px;padding:0 10px;background-color:#fff;border-radius:2px;-webkit-box-shadow:0 2px 4px rgba(0,0,0,.1);box-shadow:0 2px 4px rgba(0,0,0,.1)}._2g2AN{padding-left:4px;padding-right:4px}.wRoJh{position:relative;list-style:none;padding:15px 0 0;border-bottom:1px solid #eee;margin:0 0 20px;text-align:left}._1hRed{border-bottom:2px solid transparent;padding:0 25px 15px;font-size:15px;font-weight:400;display:inline-block;-webkit-transition:all .15s ease-out;-o-transition:all .15s ease-out;transition:all .15s ease-out;cursor:pointer;width:350px;text-align:center}._1hRed:not(:first-child){margin-left:10px}._1hRed._2YzpL{font-weight:700;border-bottom:2px solid #ffd906}._1hRed:hover{border-bottom:2px solid #ffc107;color:#e73232}.o6_BO{position:relative;display:block;border-top:1px solid #eee;margin:0 -10px 20px;text-align:center}._1P0rd{display:block;padding:10px 15px 12px;text-decoration:none;font-weight:400;font-size:18px;color:#888;cursor:pointer;-webkit-transition:all .15s ease-out;-o-transition:all .15s ease-out;transition:all .15s ease-out}._1P0rd:hover{background-color:#ffc107;color:#000}", ""]);

// exports
exports.locals = {
	"root": "_2y3kt",
	"navContainer": "_2g2AN",
	"nav": "wRoJh",
	"tab": "_1hRed",
	"active": "_2YzpL",
	"showAll": "o6_BO",
	"link": "_1P0rd"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./node_modules/postcss-loader/lib?{"config":{"path":"./tools/postcss.config.js"}}!./src/desktop/routes/home/components/SpecialAdverts/SpecialAdverts.css
// module id = 2264
// module chunks = 20 33 38